import { combineReducers } from 'redux';

import loadSiteGoogleToolError from './loadSiteGoogleToolError';
import uploadSiteGoogleToolFileError from './uploadSiteGoogleToolFileError';
import deleteSiteGoogleToolError from './deleteSiteGoogleToolError';

export default combineReducers({
  loadSiteGoogleToolError,
  uploadSiteGoogleToolFileError,
  deleteSiteGoogleToolError,
});
